import React from "react";
import DocumentMeta from "react-document-meta";
import { Link } from "react-router-dom";
import { FiExternalLink } from "react-icons/fi";
import Config from "../config.json";
import Requirement from "../Images/downloadPage.png";
import downloadImage from "../Images/productHeroImg.webp";
import downloadImage2 from "../Images/download pic.png";
import ImageSlider from "./ImageSlider";

const page_meta = {
  language: "fa",
  copyright: "پژوهیار",
  description: "نرم‌افزار استناددهی",
  title: `${Config.title} | دانلود نرم‌افزار`,
  meta: {
    charset: "utf-8",
    name: {
      keywords: "پژوهیار",
    },
  },
};

const Product = () => {
  return (
    <DocumentMeta {...page_meta}>
      <section className="hero-sample hero-sample-product">
        <div className="hero-sample-right hero-sample-right-product">
          <h1>دانلود پژوهیار</h1>
          <p>نرم‌افزار استناددهی و سازماندهی منابع پژوهشی</p>
          <a
            href="https://dl.pajoohyar.com/download/standalone/update/exe/"
            className="hero-sample-btn hero-sample-btn-product">
            دانلود مستقیم
          </a>
          <a
            target="_blunk"
            href="https://www.noorshop.ir/fa/product/74191"
            className="hero-sample-btn hero-sample-btn-product mx-0">
            دانلود از نورشاپ
          </a>
        </div>
        <div className="hero-sample-left hero-sample-left-product">
          <img
            src={downloadImage}
            alt="downloadImg"
            className="hero-sample-left-product-img1"
          />
          <img
            src={downloadImage2}
            alt="downloadImg"
            className="hero-sample-left-product-img2"
          />
        </div>
      </section>

      <section className="product-Introduction">
        <div className="shapes">
          <div className="shape shape-1"></div>
          <div className="shape shape-2"></div>
          <div className="shape shape-3"></div>
        </div>
        <div className="product-Introduction-content">
          <h1>معرفی پژوهیار</h1>
          <p>
          «پژوهیار» اولین نرم‌افزار مدیریت استناددهی متن‌باز فارسی‌زبان است که بر پایه نرم‌افزار زوترو طراحی شده است. این نرم‌افزار محققان و پژوهشگران را در امر پژوهش و مستندسازی نتایج پژوهشی یاری می‌کند. پژوهیار، ابزاری پژوهشی و قدرتمند است که به کاربران کمک می‌کند تا گردآوری، سازماندهی و تجزیه‌وتحلیل منابع علمی خود را به‌آسانی انجام دهند و سپس با تکیه بر آن بتوانند به نحوی مناسب و بر«پژوهیار» نرم‌افزار استناددهی و سازماندهی منابع پژوهشی است. این نرم‌افزار به پژوهشگران کمک می‌کند تا گردآوری، سازماندهی و مستندسازی منابع علمی موردنظر خود را به‌آسانی انجام دهند.، به مستندسازی حاصل پژوهش خود در قالب کتاب، پایان‌نامه و مقاله بپردازند. این نرم‌افزار دارای قابلیت‌های بسیاری از جمله ذخیره و طبقه‌بندی اطلاعات، یادداشت‌گذاری، استفاده از برچسب‌های مختلف، جستجوی اطلاعات ذخیره‌شده و... است. همچنین پژوهیار پیوند محکمی با منابع برخط (online) دارد، به گونه‌ای که هنگام جستجو و بازیابی اطلاعات از کتاب، مقاله، صفحات وب، تصاویر و ده‌ها قلم دیداری و شنیداری دیگر، پژوهشگر به طور خودکار می‌تواند منابع خود را در نرم‌افزار ذخیره کند و سپس برای استناددهی از این منابع با شیوه‌های مختلف اقدام نماید. این نرم‌افزار بر اساس نیاز سه‌زبانه و تلفیقی کاربران طراحی و ارائه شده است.
          </p>
        </div>
        <ImageSlider />
      </section>

      <section className="hero-sample hero-sample-product-requirement">
        <div className="hero-sample-right hero-sample-right-product-requirement">
          <h2>مشخصات نرم‌افزار</h2>
          <ul className="specs">
            <li>
              <strong>سیستم‌عامل:</strong> ویندوز 7 به بالا
            </li>
            <li>
              <strong>نرم‌افزار ورد:</strong> 2007 به بالا
            </li>
            <li>
              <strong>نسخه نرم‌افزار:</strong> 6.0.29 -{" "}
              <Link to={"/versions"} target="_blunk">
                مشخصات نسخه‌ها{" "}
                <FiExternalLink className="start-highlight-icon" />
              </Link>
            </li>
            <li>
              <strong>حجم:</strong> 50 مگابایت
            </li>
            <li>
              <strong>تولیدکننده:</strong> مرکز تحقیقات کامپیوتری علوم اسلامی
            </li>
          </ul>
          <p>
            در صورت نیاز به راهنمایی، می‌توانید به بخش{" "}
            <Link to={"/help"} target="_blunk">
              راهنما
            </Link>
            ،{" "}
            <Link to={"/faq"} target="_blunk">
              پرسش‌های متداول
            </Link>{" "}
            و یا{" "}
            <Link to={"/contact"} target="_blunk">
              ارتباط با ما
            </Link>{" "}
            مراجعه کنید.
          </p>
        </div>
        <div className="hero-sample-left hero-sample-left-product-requirement">
          <img
            src={Requirement}
            alt="downloadImg"
            className="hero-sample-left-product-requirement-img"
          />
        </div>
      </section>
    </DocumentMeta>
  );
};

export default Product;
